// React imports
import React, { useState } from 'react';

// UI – style imports
import { WithStyles, withStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

// local imports
import { styles } from './NoticePrivacy.style';
import { usePdfComponents } from '../../hooks/usePdfComponents';

function NoticePrivacy(props: WithStyles<typeof styles>) {
    const { classes } = props;

    // responsive
    const isLarge = useMediaQuery('(min-width:1200px)');
    const isMedium = useMediaQuery('(min-width:900px)');
    const isSmall = useMediaQuery('(min-width:600px)');
    const pageWidth = isLarge ? 800 : isMedium ? 600 : isSmall ? 300 : 200;

    // PDF components from shared hook
    const { DocumentComp, PageComp, isLoaded } = usePdfComponents();

    // estado PDF
    const [numPages, setNumPages] = useState<number | null>(null);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    return (
        <div>
            <Grid container className={classes.subGridTitle}>
                <Grid item xs={12}>
                    <Box className={classes.section}>
                        {isLoaded && DocumentComp && PageComp ? (
                            <DocumentComp
                                file="/legal-documents/Aviso_Privacidad.pdf"
                                onLoadSuccess={onDocumentLoadSuccess}
                            >
                                {Array.from(new Array(numPages), (_, index) => (
                                    <Box
                                        key={`page_${index + 1}`}
                                        style={{
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                            marginBottom: '20px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            backgroundColor: '#fff',
                                            padding: '10px',
                                        }}
                                    >
                                        <PageComp pageNumber={index + 1} width={pageWidth} />
                                    </Box>
                                ))}
                            </DocumentComp>
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(NoticePrivacy);
